<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span class="header-span header-span-active">{{
            $t("m.options.listTab.name")
          }}</span>
          <span class="header-span">{{ $t("m.options.listTab.model") }}</span>
          <span class="header-span">按时间</span>
          <span class="header-span">机器码</span>
        </div>
        <div class="box-header-right">
          <el-button type="primary" icon="el-icon-delete">搜索</el-button>
        </div>
      </div>
      <!--内容-->
      <div class="box-content">
        <div class="box-item box-half box-active">
          <div class="box-item-img">
            <img src="../../../assets/img/bc-active.jpg" />
          </div>
          <div class="box-item-text">
            <div>名字：导入杯测</div>
            <div>烘焙度：70%</div>
            <div>得分：57.69</div>
            <div>登记：良好</div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../../assets/img/bc.jpg" />
          </div>
          <div class="box-item-text">
            <div>名字：导入杯测</div>
            <div>烘焙度：70%</div>
            <div>得分：57.69</div>
            <div>登记：良好</div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../../assets/img/bc.jpg" />
          </div>
          <div class="box-item-text">
            <div>名字：导入杯测</div>
            <div>烘焙度：70%</div>
            <div>得分：57.69</div>
            <div>登记：良好</div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../../assets/img/bc.jpg" />
          </div>
          <div class="box-item-text">
            <div>名字：导入杯测</div>
            <div>烘焙度：70%</div>
            <div>得分：57.69</div>
            <div>登记：良好</div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-box border-1px-all">
      <section>
        <div class="flex flex-between">
          <div class="title-bc">杯测详情</div>
          <div class="line-right">
            <el-button type="primary" @click="dialogTableVisible2 = true"
              >曲线详情</el-button
            >
            <el-button type="primary" @click="dialogTableVisible = true"
              >评分标准</el-button
            >
            <el-button type="warning">{{
              $t("m.commentDetail.saveChange")
            }}</el-button>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap">
            <span>名字</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
          <div class="flex input-wrap custom-datepicker">
            <span>日期</span>
            <el-date-picker
              v-model="date"
              type="date"
              prefix-icon="none"
              :clearable="false"
              :placeholder="$t('m.table.selectDate')"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap">
            <span>得分</span>
            <el-input placeholder=""> </el-input>
          </div>
          <div class="flex input-wrap">
            <span>等级</span>
            <el-select
              v-model="selectValue"
              :placeholder="$t('m.table.select')"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex input-line">
          <div class="flex input-wrap">
            <span>反馈</span>
            <el-input placeholder=""> </el-input>
          </div>
        </div>
      </section>
      <el-divider></el-divider>
      <section>
        <div class="flex-between slider-line">
          <div class="slider-title slider-title-large">
            <span class="slider-title-text">烘焙度：</span>
            <span class="slider-title-value slider-title-warning"
              >Light:34</span
            >
          </div>
          <el-slider v-model="sliderValue"></el-slider>
        </div>
        <div class="slider-line slider-line-more">
          <div class="sub-line flex-between">
            <div class="slider-title slider-title-large">
              <span class="slider-title-text">干香/湿香：</span>
              <span class="slider-title-value ">7.50</span>
            </div>
            <el-slider v-model="sliderValue"></el-slider>
          </div>
          <div class="sub-line flex-between">
            <div class="slider-line flex-between">
              <div class="slider-title">
                <span class="slider-title-text">dry：</span>
              </div>
              <el-slider v-model="sliderValue"></el-slider>
            </div>
            <div class="slider-line flex-between">
              <div class="slider-title">
                <span class="slider-title-text">break：</span>
              </div>
              <el-slider v-model="sliderValue"></el-slider>
            </div>
          </div>
        </div>
        <div class="slider-line slider-line-depart">
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">风味值：</span>
              <span class="slider-title-value ">7.50</span>
            </div>
            <el-slider v-model="sliderValue"></el-slider>
          </div>
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">圆味值：</span>
              <span class="slider-title-value ">7.75</span>
            </div>
            <el-slider v-model="sliderValue"></el-slider>
          </div>
        </div>
        <div class="slider-line slider-line-more">
          <div class="sub-line flex-between">
            <div class="slider-line flex-between">
              <div class="slider-title">
                <span class="slider-title-text">酸度：</span>
                <span class="slider-title-value ">8.0</span>
              </div>
              <el-slider v-model="sliderValue"></el-slider>
            </div>
            <div class="slider-line flex-between">
              <div class="slider-title">
                <span class="slider-title-text">Itensity：</span>
              </div>
              <el-slider v-model="sliderValue"></el-slider>
            </div>
          </div>
        </div>
        <div class="slider-line slider-line-more">
          <div class="sub-line flex-between">
            <div class="slider-line flex-between">
              <div class="slider-title">
                <span class="slider-title-text">醇厚度：</span>
                <span class="slider-title-value ">8.0</span>
              </div>
              <el-slider v-model="sliderValue"></el-slider>
            </div>
            <div class="slider-line flex-between">
              <div class="slider-title">
                <span class="slider-title-text">Level：</span>
              </div>
              <el-slider v-model="sliderValue"></el-slider>
            </div>
          </div>
        </div>
        <div class="slider-line slider-line-depart">
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">一致性：</span>
              <span class="slider-title-value "
                >{{ num1 }}.{{ num2 }}{{ num3 }}</span
              >
            </div>
            <div class="custom-number-control">
              <el-input-number
                v-model="num1"
                controls-position="right"
                :min="0"
                :max="10"
              ></el-input-number>
              <el-input-number
                v-model="num2"
                controls-position="right"
                :min="0"
                :max="9"
              ></el-input-number>
              <el-input-number
                v-model="num3"
                controls-position="right"
                :min="0"
                :max="9"
              ></el-input-number>
            </div>
          </div>
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">干净度：</span>
              <span class="slider-title-value ">2.00</span>
            </div>
            <div class="custom-number-control">
              <el-input-number
                controls-position="right"
                :min="0"
                :max="10"
              ></el-input-number>
              <el-input-number
                controls-position="right"
                :min="0"
                :max="9"
              ></el-input-number>
              <el-input-number
                controls-position="right"
                :min="0"
                :max="9"
              ></el-input-number>
            </div>
          </div>
        </div>
        <div class="slider-line slider-line-depart">
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">平衡感：</span>
              <span class="slider-title-value ">7.50</span>
            </div>
            <el-slider v-model="sliderValue"></el-slider>
          </div>
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">甜度：</span>
              <span class="slider-title-value ">7.75</span>
            </div>
            <div class="custom-number-control">
              <el-input-number
                controls-position="right"
                :min="0"
                :max="10"
              ></el-input-number>
              <el-input-number
                controls-position="right"
                :min="0"
                :max="9"
              ></el-input-number>
              <el-input-number
                controls-position="right"
                :min="0"
                :max="9"
              ></el-input-number>
            </div>
          </div>
        </div>
        <div class="slider-line slider-line-depart">
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">总体评价：</span>
              <span class="slider-title-value ">7.50</span>
            </div>
            <el-slider v-model="sliderValue"></el-slider>
          </div>
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">Defects：</span>
              <span class="slider-title-value small">-2</span>
            </div>
            <div class="custom-number-control">
              <span>Taint=2</span>
              <el-input-number
                controls-position="right"
                :min="0"
                :max="10"
                style="margin-right:10px;"
              ></el-input-number>
              <span>Fault=4</span>
              <el-input-number
                controls-position="right"
                :min="0"
                :max="10"
              ></el-input-number>
            </div>
          </div>
        </div>
        <div class="slider-line slider-line-depart">
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">Total Score：</span>
              <span class="slider-title-value small">61.25</span>
            </div>
          </div>
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">Final Score：</span>
              <span class="slider-title-value small">61.25</span>
            </div>
          </div>
          <div class="slider-line flex-between">
            <div class="slider-title">
              <span class="slider-title-text">Notes：</span>
              <span class="slider-title-value small">5</span>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!--------评分标准弹框---------->
    <el-dialog title="评分标准" :visible.sync="dialogTableVisible">
      <el-table :data="gridData" width="100%">
        <el-table-column label="Quarlity Scale">
          <el-table-column property="good" label="6.00-Good"></el-table-column>
          <el-table-column
            property="veryGood"
            label="7.00-VeryGood"
          ></el-table-column>
          <el-table-column
            property="excellent"
            label="8.00-Excellent"
          ></el-table-column>
          <el-table-column
            property="outstanding"
            label="9.00-Outstanding"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--------曲线详情---------->
    <el-dialog
      :title="$t('m.deviceManage.bindDevice.operation.detail')"
      :visible.sync="dialogTableVisible2"
    >
      <section>
        <div class="flex flex-between">
          <div class="title-bc">曲线详情</div>
          <div class="line-right">
            <el-button type="primary">取消推荐</el-button>
            <el-button type="primary">导出PDF</el-button>
            <el-button type="primary">导出JSON</el-button>
          </div>
        </div>
        <div class="row-box">
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">报告名字：</span>
                <span class="white-text">导入曲线</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">日期：</span>
                <span class="white-text">2021.06.01</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">等级：</span>
                <span class="white-text">15</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">生豆名称：</span>
                <span class="white-text">生豆一</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">类别：</span>
                <span class="white-text">导入</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">生豆重量：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">预热温：</span>
                <span class="white-text">340</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">熟豆重量：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">烘焙度：</span>
                <span class="white-text">Light:8</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">设置星级</span>
                <span class="white-text"></span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section style="height:200px;line-height:200px;text-align:center">
        eCharts图表
      </section>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span">所有点</span>
          <span class="header-span header-span-active">事件列表</span>
        </div>
        <el-table :data="gridData2" border radius-4 width="100%">
          <el-table-column property="key1" label="事件名称"></el-table-column>
          <el-table-column property="key2" label="豆表温度"></el-table-column>
          <el-table-column property="key3" label="热风温度"></el-table-column>
          <el-table-column property="key4" label="排风温度"></el-table-column>
          <el-table-column property="key5" label="环境温度"></el-table-column>
          <el-table-column property="key6" label="ROR"></el-table-column>
        </el-table>
        <div class="flex flex-center header-common flex-between">
          <el-button type="primary">查看杯测</el-button>
          <el-pagination background layout="prev, pager, next" :total="100">
          </el-pagination>
        </div>
      </section>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "equipment-list",
  data() {
    return {
      name: "",
      date: "",
      selectValue: "",
      options: [
        {
          label: "等级一",
          value: "1",
        },
        {
          label: "等级二",
          value: "2",
        },
      ],
      sliderValue: 30,
      num1: 3,
      num2: 0,
      num3: 0,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      gridData: [
        {
          good: "6.25",
          veryGood: "7.25",
          excellent: "8.25",
          outstanding: "9.25",
        },
        {
          good: "6.50",
          veryGood: "7.50",
          excellent: "8.50",
          outstanding: "9.50",
        },
        {
          good: "6.75",
          veryGood: "7.75",
          excellent: "8.75",
          outstanding: "9.75",
        },
      ],
      gridData2: [
        {
          key1: "脱水结束",
          key2: "",
          key3: "",
          key4: "",
          key5: "",
          key6: "",
        },
        {
          key1: "一爆开始",
          key2: "",
          key3: "",
          key4: "",
          key5: "",
          key6: "",
        },
        {
          key1: "一爆开始",
          key2: "",
          key3: "",
          key4: "",
          key5: "",
          key6: "",
        },
        {
          key1: "一爆开始",
          key2: "",
          key3: "",
          key4: "",
          key5: "",
          key6: "",
        },
        {
          key1: "一爆开始",
          key2: "",
          key3: "",
          key4: "",
          key5: "",
          key6: "",
        },
      ],
    };
  },
  methods: {
    handleChange() {},
  },
};
</script>
